import { render, staticRenderFns } from "./NhapLieuCty.vue?vue&type=template&id=42dd0dd8"
import script from "./NhapLieuCty.vue?vue&type=script&lang=ts"
export * from "./NhapLieuCty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports